import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
declare var $: any
@Component({
  selector: 'app-radio-slider',
  templateUrl: './radio-slider.component.html',
  styleUrls: ['./radio-slider.component.scss']
})
export class RadioSliderComponent implements OnInit, AfterViewInit {

  @Input() fixLevel: number

  radios: any;
  userRisk: any
  bgColor = 'black';
  constructor() { }

  ngOnInit() {
    this.userRisk = sessionStorage.getItem('userRisk')
    let fix = document.getElementById('option' + this.userRisk)
    fix.setAttribute("checked", 'checked')
  }

  _onSelected(el) {
    sessionStorage.setItem('userRisk', el[0].value)
    let slider = document.getElementsByClassName('slider-bar')[0]
    slider.setAttribute('class', 'slider-bar transition-enabled level-' + el[0].value)
  }

  ngAfterViewInit() {
    this.radios = $('#radios').radiosToSlider({
      onSelect: this._onSelected,
      animation: true,
    });
    let slider = document.getElementsByClassName('slider-bar')[0]
    slider.setAttribute('class', 'slider-bar transition-enabled level-' + this.userRisk)
  }

  testSlider(riskValue) {
    sessionStorage.setItem('userRisk', riskValue)
    let slider = document.getElementsByClassName('slider-bar')[0]
    slider.setAttribute('class', 'slider-bar transition-enabled level-' + riskValue)
  }
}